import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, AlertCircleIcon } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCard } from './components/PricingCard';
import { FAQItem } from './components/FAQItem';
export function App() {
  const testimonials1 = [{
    quote: 'Organicé todo el año terapéutico en una tarde. Por fin sé exactamente qué hacer en cada sesión.',
    author: 'Valeria G.',
    location: 'Córdoba'
  }, {
    quote: 'Mis pacientes tienen mejor adherencia hace 3 meses seguidos. Nunca me había pasado.',
    author: 'Romina M.',
    location: 'Buenos Aires'
  }, {
    quote: 'Las hojas de trabajo solas ya valen todo. Mis pacientes llegan con material real para trabajar.',
    author: 'Laura P.',
    location: 'Rosario'
  }];
  const testimonials2 = [{
    quote: 'El Tomo de Reestructuración Cognitiva me organizó algo que hacía de manera intuitiva hace años.',
    author: 'Cecilia R.',
    location: 'Mendoza'
  }, {
    quote: 'Mis pacientes empezaron a volver con las hojas completadas. El proceso cambió completamente.',
    author: 'Sofía C.',
    location: 'La Plata'
  }, {
    quote: 'El protocolo de cierre solo ya vale todo. Nunca había tenido algo tan completo y tan humano.',
    author: 'Marcela T.',
    location: 'Neuquén'
  }];
  const tomos = [{
    icon: '📘',
    number: 'Tomo 1',
    name: 'Admisión y Alianza Terapéutica',
    weeks: '1-8'
  }, {
    icon: '📗',
    number: 'Tomo 2',
    name: 'Ansiedad y Regulación Emocional',
    weeks: '9-16'
  }, {
    icon: '📙',
    number: 'Tomo 3',
    name: 'Reestructuración Cognitiva y Creencias',
    weeks: '17-24'
  }, {
    icon: '📕',
    number: 'Tomo 4',
    name: 'Autoestima, Identidad y Autocompasión',
    weeks: '25-32'
  }, {
    icon: '📓',
    number: 'Tomo 5',
    name: 'Habilidades Sociales y Comunicación',
    weeks: '33-40'
  }, {
    icon: '📔',
    number: 'Tomo 6',
    name: 'Cierre, Prevención de Recaídas y Proyecto de Vida',
    weeks: '41-52'
  }];
  const bonos = [{
    number: '01',
    name: 'Kit de Implementación Express — Empezá en 10 minutos',
    value: '$8.000'
  }, {
    number: '02',
    name: 'Banco de 12 Sesiones Clave Listas Para Usar',
    value: '$10.000'
  }, {
    number: '03',
    name: 'Cuaderno de Ejercicios Entre Sesiones',
    value: '$9.000'
  }, {
    number: '04',
    name: 'Checklist Anual de Seguimiento Terapéutico',
    value: '$8.000'
  }, {
    number: '05',
    name: 'Pack de 20 Hojas Imprimibles Premium',
    value: '$9.000'
  }, {
    number: '06',
    name: 'Guía de Uso Perfecto Para Pacientes',
    value: '$9.000'
  }];
  const operacionesComparison = [{
    situation: 'Agenda caótica',
    without: 'Seguís igual',
    with: 'Bloques clínicos organizados'
  }, {
    situation: 'Honorarios a ojo',
    without: 'Perdés dinero',
    with: 'Fórmula de honorario real'
  }, {
    situation: 'Sin sistema de cobros',
    without: 'Cancelaciones sin gestionar',
    with: 'Política lista para comunicar'
  }, {
    situation: '20 pacientes mezclados',
    without: 'Caos administrativo',
    with: 'CRM clínico con semáforo'
  }, {
    situation: 'Sin estrategia de crecimiento',
    without: 'Dependés de que "te llamen"',
    with: 'Marketing ético basado en tu protocolo'
  }, {
    situation: 'Burnout acumulado',
    without: 'Se agrava solo',
    with: 'Sistema de prevención en 6 pasos'
  }];
  const costComparison = [{
    without: 'Preparar material desde cero cada semana',
    cost: '3-5 horas semanales perdidas'
  }, {
    without: 'Sin hojas de trabajo',
    cost: 'El cambio queda en sesión y no se practica'
  }, {
    without: 'Sin seguimiento clínico',
    cost: 'No sabés si el paciente avanzó o no'
  }, {
    without: 'Sin protocolo de cierre',
    cost: 'Procesos que terminan sin dirección'
  }, {
    without: 'Sin sistema de honorarios',
    cost: 'Perdés dinero sin saberlo'
  }];
  const faqs = [{
    question: '¿Sirve si recién empiezo a ejercer?',
    answer: 'Sí. Es ideal para empezar con estructura profesional desde el día uno.'
  }, {
    question: '¿Cómo lo recibo?',
    answer: 'Por email, al instante después del pago. Links de descarga directa. Acceso en menos de 5 minutos.'
  }, {
    question: '¿Funciona para psicólogos online?',
    answer: 'Sí. Todo el material es digital. Enviás las hojas por WhatsApp, compartís pantalla o trabajás en PDF completable.'
  }, {
    question: '¿Funciona con cualquier orientación teórica?',
    answer: 'Está construido desde TCC e integración. La estructura es adaptable a diferentes enfoques.'
  }, {
    question: '¿Tiene garantía real?',
    answer: '7 días completos. Devolución del 100% sin preguntas si no es lo que esperabas.'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      {/* Top Urgency Bar */}
      <div className="bg-red-600 text-white py-2 px-4 text-center text-sm font-semibold" data-id="element-1">
        ⏰ Precio de lanzamiento por tiempo limitado
      </div>

      {/* Hero Section */}
      <section className="bg-gradient-to-b from-blue-50 to-white py-12 md:py-20 px-4" data-id="element-2">
        <div className="max-w-4xl mx-auto text-center" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-bold mb-4" data-id="element-4">
            🧠 AURA BIT™
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-6xl font-bold text-gray-900 mb-4 leading-tight" data-id="element-5">
            Todo tu año de terapia.
          </motion.h1>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-6">
            Listo. Desde hoy.
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-xl md:text-2xl text-gray-700 mb-8" data-id="element-7">
            Sistema Renacer — Protocolo Clínico 365 para psicólogos y pacientes
            argentinos
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-8">
            <span className="bg-white px-4 py-2 rounded-full text-sm font-medium shadow-md" data-id="element-9">
              📄 100% PDF
            </span>
            <span className="bg-white px-4 py-2 rounded-full text-sm font-medium shadow-md" data-id="element-10">
              ⚡ Acceso en 5 min
            </span>
            <span className="bg-white px-4 py-2 rounded-full text-sm font-medium shadow-md" data-id="element-11">
              🇦🇷 Hecho para Argentina
            </span>
            <span className="bg-white px-4 py-2 rounded-full text-sm font-medium shadow-md" data-id="element-12">
              🧠 6 Tomos + 6 Bonos
            </span>
          </motion.div>

          <motion.a initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.5
        }} href="https://www.blibliotecadigital.com/checkouts/cn/hWNCQe0pQFEYe35QLnSxA4os/es-ar?_r=AQABtswiwOSVJZPwXwUqS_zvSDCvZ_oUEAfrShmGc35N_Xc&cart_link_id=vG10kkvz&preview_theme_id=152474878124" className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-xl shadow-2xl hover:shadow-3xl transition-all mb-4" data-id="element-13">
            🧠 QUIERO MI SISTEMA RENACER AHORA
          </motion.a>

          <p className="text-sm text-gray-600" data-id="element-14">
            Garantía 7 días | Pago seguro | Mercado Pago
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.6
        }} className="mt-12 md:mt-16 relative" data-id="element-15">
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-200/40 via-transparent to-amber-100/40 blur-3xl -z-10" data-id="element-16" />
            <img src="https://cdn.magicpatterns.com/uploads/os6qAnQqv2mLeYvWVxM7kd/heylloyd-image-1779387923763.png" alt="Sistema Renacer — los 6 tomos del Protocolo Clínico 365 sobre una mesa de cristal" className="w-full max-w-2xl mx-auto rounded-2xl shadow-2xl" data-id="element-17" />
            <p className="text-xs md:text-sm text-gray-500 italic mt-4" data-id="element-18">
              Representación visual del sistema. Entrega 100% digital en PDF.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Social Proof Strip */}
      <section className="bg-blue-600 text-white py-4 px-4" data-id="element-19">
        <div className="max-w-6xl mx-auto flex flex-wrap justify-center items-center gap-6 text-center" data-id="element-20">
          <span className="font-semibold" data-id="element-21">👥 +500 psicólogos confían</span>
          <span className="hidden md:inline" data-id="element-22">·</span>
          <span className="font-semibold" data-id="element-23">📚 6 Tomos listos</span>
          <span className="hidden md:inline" data-id="element-24">·</span>
          <span className="font-semibold" data-id="element-25">🎁 6 Bonos incluidos</span>
          <span className="hidden md:inline" data-id="element-26">·</span>
          <span className="font-semibold" data-id="element-27">⭐ 4.9/5</span>
        </div>
      </section>

      {/* Testimonials 1 */}
      <section className="py-16 px-4 bg-white" data-id="element-28">
        <div className="max-w-6xl mx-auto" data-id="element-29">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-30">
            {testimonials1.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-31">
                <p className="text-gray-700 mb-4 italic" data-id="element-32">
                  "{testimonial.quote}"
                </p>
                <p className="font-semibold text-gray-900" data-id="element-33">
                  — {testimonial.author} · {testimonial.location}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-34">
        <div className="max-w-4xl mx-auto text-center" data-id="element-35">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-36">
            ¿Cuántos domingos más vas a preparar material desde cero?
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-lg text-gray-700 space-y-4 mb-8" data-id="element-37">
            <p data-id="element-38">Sos psicólogo/a. Amás lo que hacés.</p>
            <p data-id="element-39">
              Pero nadie te dijo que ibas a pasar los domingos sin saber cómo
              estructurar la próxima semana, con sesiones que se sienten
              circulares, pacientes que abandonan sin cierre real, y preparando
              hojas desde cero para cada consulta.
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl font-bold text-gray-900 mb-8" data-id="element-40">
            No es falta de formación. Es falta de un sistema.
          </motion.p>

          {/* Pain List */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-red-50 border-2 border-red-200 rounded-xl p-8 text-left" data-id="element-41">
            <h3 className="text-xl font-bold text-red-900 mb-6 text-center" data-id="element-42">
              ❌ Sin sistema
            </h3>
            <ul className="space-y-4" data-id="element-43">
              <li className="flex items-start gap-3" data-id="element-44">
                <XIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-45" />
                <span className="text-gray-800" data-id="element-46">
                  Sesiones sin dirección semana a semana
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-47">
                <XIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-48" />
                <span className="text-gray-800" data-id="element-49">
                  Pacientes que abandonan antes del cierre real
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-50">
                <XIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-51" />
                <span className="text-gray-800" data-id="element-52">
                  Sin hojas de trabajo — nada se practica entre sesiones
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-53">
                <XIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-54" />
                <span className="text-gray-800" data-id="element-55">
                  Sin seguimiento — no sabés si avanzaron o no
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-56">
                <XIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-57" />
                <span className="text-gray-800" data-id="element-58">
                  Preparás todo desde cero cada domingo
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </section>

      {/* Bridge */}
      <section className="py-12 px-4 bg-white" data-id="element-59">
        <div className="max-w-4xl mx-auto text-center" data-id="element-60">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-61">
            ¿Y si este fuera el último domingo que pasás así?
          </motion.h2>
        </div>
      </section>

      {/* Solution Reveal */}
      <section className="py-16 px-4 bg-gradient-to-b from-green-50 to-white" data-id="element-62">
        <div className="max-w-6xl mx-auto text-center" data-id="element-63">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-64">
            🏆 SISTEMA RENACER
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-3xl font-semibold text-gray-700 mb-12" data-id="element-65">
            6 Tomos + 6 Bonos. Todo resuelto.
          </motion.p>

          {/* Tomos Table */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-16" data-id="element-66">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8" data-id="element-67">
              📚 LOS 6 TOMOS
            </h3>

            <div className="mb-10 relative" data-id="element-68">
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-100/50 via-transparent to-amber-50/50 blur-3xl -z-10" data-id="element-69" />
              <img src="https://cdn.magicpatterns.com/uploads/os6qAnQqv2mLeYvWVxM7kd/heylloyd-image-1779387923763.png" alt="Los 6 tomos del Sistema Renacer dispuestos sobre una mesa" className="w-full max-w-xl mx-auto rounded-2xl shadow-xl" data-id="element-70" />
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-8" data-id="element-71">
              <div className="overflow-x-auto" data-id="element-72">
                <table className="w-full" data-id="element-73">
                  <thead className="bg-blue-600 text-white" data-id="element-74">
                    <tr data-id="element-75">
                      <th className="px-4 py-4 text-left font-semibold" data-id="element-76">
                        Tomo
                      </th>
                      <th className="px-4 py-4 text-left font-semibold" data-id="element-77">
                        Nombre
                      </th>
                      <th className="px-4 py-4 text-left font-semibold" data-id="element-78">
                        Semanas
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-79">
                    {tomos.map((tomo, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-80">
                        <td className="px-4 py-4 font-semibold" data-id="element-81">
                          {tomo.icon} {tomo.number}
                        </td>
                        <td className="px-4 py-4" data-id="element-82">{tomo.name}</td>
                        <td className="px-4 py-4 font-semibold" data-id="element-83">
                          {tomo.weeks}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="bg-blue-50 rounded-xl p-6 text-left max-w-3xl mx-auto" data-id="element-84">
              <p className="font-bold text-gray-900 mb-4" data-id="element-85">Cada tomo incluye:</p>
              <ul className="space-y-3" data-id="element-86">
                <li className="flex items-start gap-3" data-id="element-87">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-88" />
                  <span className="text-gray-800" data-id="element-89">
                    Guía clínica sesión por sesión para el terapeuta
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-90">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-91" />
                  <span className="text-gray-800" data-id="element-92">
                    Hojas de trabajo listas para el paciente
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-93">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-94" />
                  <span className="text-gray-800" data-id="element-95">
                    Checklists de cierre semanal
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-96">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-97" />
                  <span className="text-gray-800" data-id="element-98">
                    Protocolos de crisis y revisión de avance
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-99">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-100" />
                  <span className="text-gray-800" data-id="element-101">
                    100% adaptado a la realidad argentina
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Bonos Table */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-102">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-103">
              🎁 LOS 6 BONOS
            </h3>
            <p className="text-xl text-gray-700 mb-8" data-id="element-104">Siempre incluidos</p>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-6" data-id="element-105">
              <div className="overflow-x-auto" data-id="element-106">
                <table className="w-full" data-id="element-107">
                  <thead className="bg-green-600 text-white" data-id="element-108">
                    <tr data-id="element-109">
                      <th className="px-4 py-4 text-left font-semibold" data-id="element-110">#</th>
                      <th className="px-4 py-4 text-left font-semibold" data-id="element-111">
                        Bono
                      </th>
                      <th className="px-4 py-4 text-left font-semibold" data-id="element-112">
                        Valor
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-113">
                    {bonos.map((bono, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-114">
                        <td className="px-4 py-4 font-bold text-green-600" data-id="element-115">
                          {bono.number}
                        </td>
                        <td className="px-4 py-4" data-id="element-116">{bono.name}</td>
                        <td className="px-4 py-4" data-id="element-117">
                          <span className="line-through text-gray-400 mr-2" data-id="element-118">
                            {bono.value}
                          </span>
                          <span className="font-bold text-green-600" data-id="element-119">
                            GRATIS
                          </span>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>

            <p className="text-lg font-semibold text-gray-900" data-id="element-120">
              Valor total bonos:{' '}
              <span className="line-through text-gray-400" data-id="element-121">$53.000</span> →
              <span className="text-green-600 ml-2" data-id="element-122">
                GRATIS con tu Sistema Renacer
              </span>
            </p>
          </motion.div>
        </div>
      </section>

      {/* Countdown Section */}
      <section className="py-16 px-4 bg-red-600 text-white" data-id="element-123">
        <div className="max-w-4xl mx-auto text-center" data-id="element-124">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-8" data-id="element-125">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </motion.h2>

          <CountdownTimer className="mb-8" data-id="element-126" />

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl font-semibold" data-id="element-127">
            Después sube $8.000 ARS. No vuelve.
          </motion.p>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-16 px-4 bg-gray-50" data-id="element-128">
        <div className="max-w-6xl mx-auto" data-id="element-129">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-130">
            ELEGÍ TU SISTEMA RENACER
          </motion.h2>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-131">
            <PricingCard icon="📘" title="SISTEMA RENACER" subtitle="PROTOCOLO CLÍNICO 365 — 6 Tomos + 6 Bonos" oldPrice="$51.000" newPrice="$19.990" ctaText="→ QUIERO MI SISTEMA RENACER" ctaLink="https://www.blibliotecadigital.com/checkouts/cn/hWNCQe0pQFEYe35QLnSxA4os/es-ar?_r=AQABtswiwOSVJZPwXwUqS_zvSDCvZ_oUEAfrShmGc35N_Xc&cart_link_id=vG10kkvz&preview_theme_id=152474878124" data-id="element-132" />

            <PricingCard icon="🏆" title="SISTEMA RENACER + OPERACIONES CLÍNICAS 360" subtitle="6 Tomos + 6 Bonos + Sistema completo de gestión del consultorio" oldPrice="$69.000" newPrice="$27.990" ctaText="→ QUIERO SISTEMA RENACER + OPERACIONES CLÍNICAS 360" ctaLink="https://www.blibliotecadigital.com/checkouts/cn/hWNCQeP9PPeYNdcW5eAu6Ass/es-ar?_r=AQABe6-1GgqqGzwPNTj7XI_lrhDoFIJlPUIXTbIYaETThbI&cart_link_id=Ttn3cQih&preview_theme_id=152474878124" isPopular={true} data-id="element-133" />
          </div>
        </div>
      </section>

      {/* Operaciones 360 Comparison */}
      <section className="py-16 px-4 bg-white" data-id="element-134">
        <div className="max-w-6xl mx-auto" data-id="element-135">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-136">
            ¿Qué agrega Operaciones Clínicas 360?
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-137">
            <div className="overflow-x-auto" data-id="element-138">
              <table className="w-full" data-id="element-139">
                <thead className="bg-blue-600 text-white" data-id="element-140">
                  <tr data-id="element-141">
                    <th className="px-4 py-4 text-left font-semibold" data-id="element-142">
                      Situación
                    </th>
                    <th className="px-4 py-4 text-left font-semibold" data-id="element-143">
                      ❌ Sin
                    </th>
                    <th className="px-4 py-4 text-left font-semibold" data-id="element-144">
                      ✅ Con
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-145">
                  {operacionesComparison.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-146">
                      <td className="px-4 py-4 font-semibold" data-id="element-147">
                        {row.situation}
                      </td>
                      <td className="px-4 py-4 text-red-600" data-id="element-148">{row.without}</td>
                      <td className="px-4 py-4 text-green-600 font-semibold" data-id="element-149">
                        {row.with}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Testimonials 2 */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-150">
        <div className="max-w-6xl mx-auto" data-id="element-151">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-152">
            ❤️ MÁS PSICÓLOGOS QUE YA LO TIENEN
          </motion.h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-153">
            {testimonials2.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-6 rounded-xl shadow-md" data-id="element-154">
                <p className="text-gray-700 mb-4 italic" data-id="element-155">
                  "{testimonial.quote}"
                </p>
                <p className="font-semibold text-gray-900" data-id="element-156">
                  — {testimonial.author} · {testimonial.location}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-16 px-4 bg-white" data-id="element-157">
        <div className="max-w-4xl mx-auto text-center" data-id="element-158">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-green-50 border-4 border-green-500 rounded-2xl p-8 md:p-12" data-id="element-159">
            <div className="text-6xl mb-6" data-id="element-160">🛡️</div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-161">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-162">
              Abrís los tomos. Los usás en tu consultorio. Si en 7 días no es lo
              que esperabas: devolución del 100% sin formularios, sin drama.
            </p>
            <p className="text-xl font-bold text-green-600" data-id="element-163">
              Tasa de devoluciones: menos del 1%.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Cost Comparison */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-164">
        <div className="max-w-5xl mx-auto" data-id="element-165">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-166">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-167">
            <div className="overflow-x-auto" data-id="element-168">
              <table className="w-full" data-id="element-169">
                <thead className="bg-red-600 text-white" data-id="element-170">
                  <tr data-id="element-171">
                    <th className="px-4 py-4 text-left font-semibold" data-id="element-172">
                      Sin Sistema Renacer
                    </th>
                    <th className="px-4 py-4 text-left font-semibold" data-id="element-173">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-174">
                  {costComparison.map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-175">
                      <td className="px-4 py-4" data-id="element-176">{row.without}</td>
                      <td className="px-4 py-4 font-semibold text-red-600" data-id="element-177">
                        {row.cost}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </motion.div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 px-4 bg-white" data-id="element-178">
        <div className="max-w-4xl mx-auto" data-id="element-179">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-180">
            ❓ PREGUNTAS FRECUENTES
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-181">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-182" />)}
          </motion.div>
        </div>
      </section>

      {/* Final Countdown + Pricing */}
      <section className="py-16 px-4 bg-gradient-to-b from-red-50 to-gray-50" data-id="element-183">
        <div className="max-w-6xl mx-auto" data-id="element-184">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-185">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-186">
              ⏰ EL PRECIO CIERRA EN:
            </h2>
            <CountdownTimer data-id="element-187" />
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12" data-id="element-188">
            <PricingCard icon="📘" title="SISTEMA RENACER" subtitle="6 Tomos + 6 Bonos" oldPrice="$51.000" newPrice="$19.990" ctaText="→ QUIERO MI SISTEMA RENACER" ctaLink="https://www.blibliotecadigital.com/checkouts/cn/hWNCQe0pQFEYe35QLnSxA4os/es-ar?_r=AQABtswiwOSVJZPwXwUqS_zvSDCvZ_oUEAfrShmGc35N_Xc&cart_link_id=vG10kkvz&preview_theme_id=152474878124" data-id="element-189" />

            <PricingCard icon="🏆" title="SISTEMA RENACER + OPERACIONES CLÍNICAS 360" subtitle="6 Tomos + 6 Bonos + Sistema completo de gestión del consultorio" oldPrice="$69.000" newPrice="$27.990" ctaText="→ QUIERO SISTEMA RENACER + OPERACIONES CLÍNICAS 360" ctaLink="https://www.blibliotecadigital.com/checkouts/cn/hWNCQeP9PPeYNdcW5eAu6Ass/es-ar?_r=AQABe6-1GgqqGzwPNTj7XI_lrhDoFIJlPUIXTbIYaETThbI&cart_link_id=Ttn3cQih&preview_theme_id=152474878124" isPopular={true} data-id="element-190" />
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-wrap justify-center gap-6 text-center" data-id="element-191">
            <span className="flex items-center gap-2 font-semibold text-gray-700" data-id="element-192">
              <CheckIcon className="w-5 h-5 text-green-600" data-id="element-193" />
              Pago seguro
            </span>
            <span className="flex items-center gap-2 font-semibold text-gray-700" data-id="element-194">
              <CheckIcon className="w-5 h-5 text-green-600" data-id="element-195" />
              Acceso en 5 min
            </span>
            <span className="flex items-center gap-2 font-semibold text-gray-700" data-id="element-196">
              <CheckIcon className="w-5 h-5 text-green-600" data-id="element-197" />
              Garantía 7 días
            </span>
            <span className="flex items-center gap-2 font-semibold text-gray-700" data-id="element-198">
              <CheckIcon className="w-5 h-5 text-green-600" data-id="element-199" />
              Mercado Pago
            </span>
          </motion.div>
        </div>
      </section>

      {/* Closing Emotional Line */}
      <section className="py-16 px-4 bg-blue-600 text-white" data-id="element-200">
        <div className="max-w-4xl mx-auto text-center" data-id="element-201">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-202">
            🧠 "El próximo lunes puede ser completamente diferente."
          </motion.h2>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-4" data-id="element-203">
        <div className="max-w-6xl mx-auto" data-id="element-204">
          <div className="text-center mb-8" data-id="element-205">
            <h3 className="text-3xl font-bold mb-4" data-id="element-206">🧠 AURA BIT™</h3>
            <p className="text-gray-400 max-w-2xl mx-auto mb-6" data-id="element-207">
              El sistema N°1 para psicólogos que ejercen de manera privada en
              Argentina. Porque tener una práctica clínica ordenada no debería
              costarte todos los domingos del año.
            </p>
            <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm" data-id="element-208">
              <a href="mailto:soportebibliotecad@gmail.com" className="hover:text-blue-400 transition-colors" data-id="element-209">
                📧 soportebibliotecad@gmail.com
              </a>
              <span className="hidden md:inline" data-id="element-210">|</span>
              <a href="https://www.bibliotecadigital.com" className="hover:text-blue-400 transition-colors" data-id="element-211">
                🌐 www.bibliotecadigital.com
              </a>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-400" data-id="element-212">
            <p className="mb-6" data-id="element-213">
              © Aura Bit™ 2026 — Todos los derechos reservados. Prohibida la
              reproducción y redistribución sin autorización expresa.
            </p>

            <div className="bg-gray-800 rounded-xl p-6 max-w-2xl mx-auto" data-id="element-214">
              <h4 className="font-bold text-white mb-4" data-id="element-215">Próximo paso</h4>
              <div className="grid grid-cols-2 gap-3 text-left" data-id="element-216">
                <div data-id="element-217">
                  <span className="font-semibold text-blue-400" data-id="element-218">📱 ADS</span>
                  <p className="text-xs mt-1" data-id="element-219">
                    Escribí ADS para los copies de Meta Ads
                  </p>
                </div>
                <div data-id="element-220">
                  <span className="font-semibold text-blue-400" data-id="element-221">📧 EMAIL</span>
                  <p className="text-xs mt-1" data-id="element-222">
                    Escribí EMAIL para la secuencia post-compra
                  </p>
                </div>
                <div data-id="element-223">
                  <span className="font-semibold text-blue-400" data-id="element-224">🎨 DISEÑO</span>
                  <p className="text-xs mt-1" data-id="element-225">
                    Escribí DISEÑO para el maquetado visual en Canva
                  </p>
                </div>
                <div data-id="element-226">
                  <span className="font-semibold text-blue-400" data-id="element-227">
                    🚀 LANZAMIENTO
                  </span>
                  <p className="text-xs mt-1" data-id="element-228">
                    Escribí LANZAMIENTO para el plan paso a paso
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}